import { Box } from '~/design-system';
import { Helmet } from 'react-helmet';
import TopNavbar from './TopNavbar';

export default function Layout({ children }) {
  return (
    <Box sx={{ backgroundColor: 'brand.white', minHeight: '100vh' }}>
      <Helmet>
        <title>Imports - Bottlebooks</title>
      </Helmet>
      <TopNavbar />
      <Box sx={{ textAlign: 'center', paddingTop: 5, paddingBottom: 120 }}>
        {children}
      </Box>
    </Box>
  );
}
